module.exports = __webpack_public_path__ + "static/media/worldmap.9d79b9d4.jpg";